import cumulus from "./cumulus";
import chauffeEau from "./chauffeEau";
import entretienChaudiere from "./entretienChaudiere";
import problemeChasse from "./problemeChasse";
import debouchage from "./debouchage";
import rechercheFuite from "./rechercheFuite";
import CONSTANTS from "../utils/constants";

import showdown from "showdown";
const pages = {
  [CONSTANTS.CONTENT_PAGE_REFERENCES.CUMULUS]: convertPageToHtml(cumulus),
  [CONSTANTS.CONTENT_PAGE_REFERENCES.CHAUFFE_EAU]: convertPageToHtml(
    chauffeEau
  ),
  [CONSTANTS.CONTENT_PAGE_REFERENCES.ENTRETIEN_CHAUDIERE]: convertPageToHtml(
    entretienChaudiere
  ),
  [CONSTANTS.CONTENT_PAGE_REFERENCES.PROBLEME_CHASSE]: convertPageToHtml(
    problemeChasse
  ),
  [CONSTANTS.CONTENT_PAGE_REFERENCES.DEBOUCHAGE]: convertPageToHtml(debouchage),
  [CONSTANTS.CONTENT_PAGE_REFERENCES.RECHERCHE_FUITE]: convertPageToHtml(
    rechercheFuite
  ),
};

function convertPageToHtml(page) {
  const converter = new showdown.Converter();
  const pageAsHtml = { ...page };
  // Section 1 - Text
  pageAsHtml.section1.text = converter.makeHtml(page.section1.text);

  // Section 2 - CTA Text
  pageAsHtml.section2.ctaText = converter.makeHtml(page.section2.ctaText);

  // Section 2 - CTA Text on mobile
  pageAsHtml.section2.ctaTextMobile = converter.makeHtml(
    page.section2.ctaTextMobile
  );
  return pageAsHtml;
}

export default pages;
